import Component from "../component.abstract"


/**
 * Houdini Component
 * force a dispay:block on a element for SEO purpose
 */
export default class Houdini extends Component {
    constructor(
        private props:unknown,
        element:HTMLElement
    ) {
        super(props, element)
    }

    mounted():void {
        this.element.removeAttribute("data-houdini");
    }
}